import { pathgen } from 'object-path-generator';
export const EditServiceContentModalTestIds = pathgen('EditServiceContentModalTestIds');
